import styled, { css } from "styled-components";

import { colorsPalettes, rgba, setFontVariant, $robotoFontFamily, fonts } from "@similarweb/styles";

export const StyledHeader = styled.h5`
    ${setFontVariant("h5_2")}
    margin-bottom: 36px;
`;

export const StyledText = styled.p`
    ${setFontVariant("body1", colorsPalettes.carbon[400])}
    margin-bottom: 16px;
`;

export const modalStyles = {
    content: {
        padding: "20px 24px",
        width: 550,
    },
};

export const StyledButtonsContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    margin-top: 32px;
`;

export const StyledTextareaContainer = styled.div<{ focus?: boolean }>`
    position: relative;
    display: flex;
    padding: 16px 0 31px 16px;
    border: 1px solid #d1d6dd;
    border-radius: 3px;
    background-color: ${colorsPalettes.carbon[0]};
    ${({ focus }) =>
        focus &&
        css`
            box-shadow: 0 3px 5px 0 ${rgba(colorsPalettes.carbon[500], 0.12)};
            border-color: ${colorsPalettes.blue[400]};
        `}
`;

export const StyledTextarea = styled.textarea`
    resize: none;
    height: 72px;
    width: 100%;
    border: none;
    color: ${rgba(colorsPalettes.carbon[500], 0.8)};
    font-family: ${$robotoFontFamily};
    font-size: 14px;
    line-height: 16px;
    padding: 0 16px 0 0;
    margin: 0;
    box-shadow: none;
    &::placeholder {
        color: ${rgba(colorsPalettes.carbon[500], 0.4)};
    }
    &:focus {
        outline: none;
    }
`;

export const StyledCounter = styled.div<{ isFull: boolean }>`
    position: absolute;
    bottom: 8px;
    right: 8px;
    color: ${rgba(colorsPalettes.carbon[500], 0.2)};
    font-family: ${fonts.$robotoFontFamily};
    font-size: 14px;
    line-height: 16px;
    ${({ isFull }) =>
        isFull &&
        css`
            color: ${rgba(colorsPalettes.carbon[500], 0.8)};
        `}
`;

export const StyledPositionRelative = styled.div`
    position: relative;
`;
